import { render } from "./ShopCartMenu.vue?vue&type=template&id=65cd16fc&scoped=true&bindings={\"cartOpen\":\"data\",\"cart\":\"options\",\"toggleCart\":\"options\"}"
import script from "./ShopCartMenu.vue?vue&type=script&lang=js"
export * from "./ShopCartMenu.vue?vue&type=script&lang=js"

import "./ShopCartMenu.vue?vue&type=style&index=0&id=65cd16fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65cd16fc"

export default script